import { render, staticRenderFns } from "./ActBaseMusic.vue?vue&type=template&id=7374461b&scoped=true&"
import script from "./ActBaseMusic.vue?vue&type=script&lang=js&"
export * from "./ActBaseMusic.vue?vue&type=script&lang=js&"
import style0 from "./ActBaseMusic.vue?vue&type=style&index=0&id=7374461b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7374461b",
  null
  
)

export default component.exports